import { render, staticRenderFns } from "./PackagingDialog.vue?vue&type=template&id=4c92b017&"
import script from "./PackagingDialog.vue?vue&type=script&lang=js&"
export * from "./PackagingDialog.vue?vue&type=script&lang=js&"
import style0 from "./PackagingDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackagingDialog.vue"
export default component.exports